import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotifyService } from '@services/notify.service';
import { SessionService } from '@services/session.service';

@Injectable()
export class ToastrInterceptor implements HttpInterceptor {

  constructor(
    private readonly notifyService: NotifyService,
    private readonly sessionService: SessionService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.maybeNotify(error, request);
        return throwError(() => error);
      }),
    );
  }

  private maybeNotify(error: HttpErrorResponse, request: HttpRequest<unknown>): void {
    if (error.status === 401 || this.sessionService.isExpired) return;

    const authHeader = request.headers.get('authorization') ?? '';
    if (!authHeader.startsWith('Bearer')) return;

    this.handleApiError(error, request.url);
  }

  private handleApiError(error: HttpErrorResponse, url: string): void {
    if (error.error && typeof error.error === 'string') {
      this.notifyService.showError('Atenção!', error.error);
      return;
    }

    if (typeof error.error?.[0]?.message === 'string') {
      this.notifyService.showError('Atenção!', error.error[0].message);
      return;
    }

    if (typeof error.error?.message === 'string') {
      const msg = error.error.message.replace('Dual Tag', 'Super Tag');
      this.notifyService.showError('Atenção!', msg);
      return;
    }

    if (error.error?.warning) {
      this.notifyService.showWarning('Atenção!', error.error.message);
      return;
    }

    if (!this.isGetGroupsByCurrentUser(url)) {
      this.notifyService.showError(
        'Atenção!',
        'Ocorreu um erro. Tente novamente. Se o erro persistir, entre em contato com os canais de atendimento.',
      );
    }
  }

  private isGetGroupsByCurrentUser(url: string): boolean {
    const parts = new Set(url.split('?')[0].split('/'));
    return (
      parts.has('CustomerPortal') &&
      parts.has('User') &&
      parts.has('GetGroupsByCurrentUser')
    );
  }
}
